import { tw } from '@tw';

/**
 * THE height of anything that stands on its own in the bar — the capsule, a
 * pill beside it, the burger, the mark. A segment is `h-9` and the
 * capsule pads it by 4px a side, so 36 + 8 = 44, which is also the touch
 * minimum. It was 52 until 2026-10-05, and a solid Sign in at 52 dwarfed its words.
 */
export const BAR_H = 'h-11';

/**
 * The bar's corners, after the landing's teammate pills (a 28px face at 10 inside a 36px
 * pill at 14): a rounded tile, not a stadium. A segment IS that pill, and the capsule's
 * 18 is its 14 plus the 4px padding, so the two corners run parallel.
 */
export const BAR_RADIUS = 'rounded-[18px]';
export const SEGMENT_RADIUS = 'rounded-[14px]';

/**
 * The bar's material: solid ink cut to the logo's tile (`.mm-tile-pill`), no edge and no
 * shadow, reversed over a card of the page's opposite colour (`useOppositeGround`). Sign
 * in, the capsule and the burger all wear it, so the bar reads as one set of objects.
 */
export function barInk(flipped: boolean): string {
  return flipped
    ? 'bg-[var(--bar-mine-fg)] text-[var(--bar-mine)]'
    : 'bg-[var(--bar-mine)] text-[var(--bar-mine-fg)]';
}

/** The shortcut capsule: one ink tile holding its segments. Colours come from `barInk`. */
export const BAR_CAPSULE = tw(
  BAR_H,
  'mm-tile-pill pointer-events-auto flex items-center gap-0.5 p-1'
);

/**
 * A segment inside the ink capsule. The one you are standing in is cut out of the ink in
 * the page's colours, the way a dark segmented control lights its choice; the others are
 * quiet words on the ink. `flipped` follows the capsule's own reversal.
 */
export function segmentPill(here: boolean, flipped: boolean): string {
  return tw(
    'mm-btn mm-tile-pill flex h-9 items-center px-3.5 text-bar font-medium whitespace-nowrap outline-none [--tile-end:1.125rem] focus-visible:shadow-[inset_0_0_0_2px_currentColor]',
    here ? barInk(!flipped) : 'hover:opacity-80'
  );
}

/** A row of the menu sheet, which stays the bar's raised white panel. */
export const SHEET_ROW = tw(
  SEGMENT_RADIUS,
  'mm-btn flex h-9 items-center px-3.5 text-bar font-medium whitespace-nowrap text-[var(--bar-fg)] hover:bg-[var(--bar-sel)]'
);
